<template>
    <!-- 成功提示 -->
    <div class="success-box posi-relative">
        <p :class="{'txt-center-noTitle':!title}">
            <img src="../../assets/img/register-icon-success.png">
        </p>
        <p class="posi-absolute">{{title}}</p>
    </div>
</template>
<script>
    export default {
        props:['title']
    }
</script>
<style lang="less" scoped>
    .success-box{
        width:30rem;
        margin:0 auto;
        padding:3rem 0 .8rem;
        border-bottom: .05rem solid #EFEFEF;
        p:first-child{
            padding-left: 5rem;
        }
        p:last-child{
            top:6.5rem; 
            left:13rem; 
            font-size: 1rem; 
            font-weight: bold;
        }
        .txt-center-noTitle{
            padding-left: 0 !important;
            text-align: center;
        }
    }
    
</style>
<style lang="less">
    .success-box + .btn-box{ 
		padding-left:18rem;
        padding-top:1rem;
        p{ 
            padding-bottom:.5rem; 
            span:first-child{
                color:#666;
            }
        } 
        p:last-child{ padding-top:1rem; } 
	}
</style>




// WEBPACK FOOTER //
// src/components/BaseCpts/resultSuccess.vue